import { styled } from "@linaria/react"

import type { LinariaClassName } from "@linaria/core"
import type { Property } from "csstype"
import type { HTMLAttributes, RefAttributes } from "react"

type SquircleProps = HTMLAttributes<HTMLDivElement> & RefAttributes<HTMLDivElement> & {
  className?: LinariaClassName,
  radius?: Property.BorderRadius,
  fill?: Property.Color
}


export const Squircle = ({ className, children, ref, ...props }: SquircleProps) => {
  if (globalThis.__squircle_ready) {
    return <StyledSquircle className={className} ref={ref} {...props}>{children}</StyledSquircle>
  } else {
    return <StyledSquircleFallback className={className} ref={ref} {...props}>{children}</StyledSquircleFallback>
  }
}

export const StyledSquircle = styled.div<{
  radius?: Property.BorderRadius
  fill?: Property.Color
}>`
  overflow: hidden;

  filter: drop-shadow(0 4px 40px var(--text-color-5));
  background: var(--paint-squircle);

  --squircle-smooth: 1;
  --squircle-radius: ${props => props.radius || "var(--squircle-border-radius, var(--border-radius-12))"};
  --squircle-fill: ${props => props.fill || "var(--squircle-background-color, var(--island-background-color))"};
`

export const StyledSquircleFallback = styled.div<{
  radius?: Property.BorderRadius
  fill?: Property.Color
}>`
  overflow: hidden;

  border: 1px solid var(--squircle-fill);
  border-radius: ${props => props.radius || "var(--squircle-border-radius, var(--border-radius-12))"};
  background-color: ${props => props.fill || "var(--squircle-background-color, var(--island-background-color))"};
`
